import State from '../core/State';
import { SummaryData } from '@kaizenplatform/intelligence-entity';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startFetchingBusinessSummary = () =>
  produce((draft: Draft<State>) => {
    draft.businessSummary.fetching = draft.businessSummary.fetching + 1;
  });

export const setBusinessSummary = (summaries: SummaryData[]) =>
  produce((draft: Draft<State>) => {
    draft.businessSummary.data = summaries;
  });

export const finishFetchingBusinessSummary = () =>
  produce((draft: Draft<State>) => {
    draft.businessSummary.fetching = draft.businessSummary.fetching - 1;
  });

export const disposeBusinessSummary = () =>
  produce((draft: Draft<State>) => {
    draft.businessSummary.data = initialState.businessSummary.data;
    draft.businessSummary.fetching = initialState.businessSummary.fetching;
  });
